import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import CloseIcon from "@mui/icons-material/Close";
import Select from "@mui/material/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import PropTypes from "prop-types";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import DoneIcon from "@mui/icons-material/Done";
import DangerousIcon from "@mui/icons-material/Dangerous";
import Box from "@mui/material/Box";

const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
export default function User() {
  const classes = useStyles();
  const [roles, setroles] = React.useState([]);
  const [openthemuser, setOpenuser] = React.useState(false);
  const [openupdateuser, setOpenupdateuser] = React.useState(false);
  const [openwarning, setOpenWarning] = React.useState(false);
  const [warrningContent, setWarrningContent] = React.useState("");
  const [updateLoaiUser, setUpdateLoaiUser] = React.useState("");
  const [updateId, setUpdateId] = React.useState("");
  const [pageSize, setPageSize] = React.useState(50);

  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [icon, setIcon] = React.useState(AddAlert);
  const [color, setColor] = React.useState("warning");
  const [listUsers, setlistUsers] = React.useState([]);
  const [updateObj, setUpdateObj] = React.useState({});
  const [addObj, setAddObj] = React.useState({});
  const [disableBT, setDisableBT] = React.useState(true);
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  // Xử lú API
  const token = localStorage.getItem("token");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getListUsers = () => {
    var url = Config.backend + "/api/users/getuser";
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setlistUsers(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getroles = () => {
    var url = Config.backend + "/api/roles/roles";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setroles(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const resetmatkhau = () => {
    var url = Config.backend + "/api/Users/resetmk?id=" + updateId;
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
    })
      .then((data) => {
        if (data) showNotification1();
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const themUser = () => {
    var url = Config.backend + "/api/users/them";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        firstName: addObj.firstName,
        username: addObj.username,
        lastName: "",
        role: addObj.role,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error("Something went wrong");
      })
      .then(() => {
        handleClose();
        getListUsers();
        showNotification(
          "Thêm user thành công, Bạn phải gán User vào đơn vị để thực hiện báo cáo",
          DoneIcon,
          "success"
        );
      })
      .catch((error) => {
        handleClose();
        console.error("Error fetching data: ", error);
        showNotification("Thêm user thất bại", DangerousIcon, "danger");
      });
  };

  const suaUser = () => {
    var url = Config.backend + "/api/users/capnhat?id=" + updateObj.id;
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        firstName: updateObj.firstName,
        //username: updateObj.username,
        lastName: "",
        role: updateObj.role,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error("Something went wrong");
      })
      .then(() => {
        handleupdateClose();
        getListUsers();
        showNotification("Cập nhật user thành công", DoneIcon, "success");
      })
      .catch((error) => {
        handleupdateClose();
        console.error("Error fetching data: ", error);
        showNotification("Cập nhật user thất bại", DangerousIcon, "danger");
      });
  };
  const changeStatus = () => {
    if (updateId === "") {
      setWarrningContent("Bạn chưa chọn  user để đổi trạng thái !!!");
      setOpenWarning(true);
    } else {
      if (updateLoaiUser) {
        let url = Config.backend + "/api/Users/deactiveUser?id=" + updateId;
        fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json, text/plain",
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Bearer " + token,
          },
        })
          .then(() => {
            setUpdateLoaiUser("");
            setUpdateId("");
            getListUsers();
            showNotification("Deactive user thành công", DoneIcon, "success");
          })
          .catch((error) => {
            console.error("Error fetching data: ", error);
            showNotification("Deactive user thất bại", DangerousIcon, "danger");
          });
      } else {
        let url = Config.backend + "/api/Users/activeUser?id=" + updateId;
        fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json, text/plain",
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Bearer " + token,
          },
        })
          .then(() => {
            setUpdateLoaiUser("");
            setUpdateId("");
            getListUsers();
            showNotification("Active user thành công", DoneIcon, "success");
          })
          .catch((error) => {
            console.error("Error fetching data: ", error);
            showNotification("Active user thất bại", DangerousIcon, "danger");
          });
      }
    }
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 3000);
  };
  const StatusRow = (props) => {
    const { params } = props;
    if (params.row.isActive) {
      return <span> Đang hoạt động</span>;
    } else {
      return <span style={{ color: "#bbb" }}> Ngưng hoạt động</span>;
    }
  };
  StatusRow.propTypes = {
    params: PropTypes.object,
  };

  const userscolumn = [
    {
      field: "id",
      headerName: "id",
      width: 50,
      headerAlign: "center",
      cellClassName: "center",
    },
    {
      field: "firstName",
      headerName: "FirstName",
      width: 170,
      headerAlign: "center",
    },
    {
      field: "lastName",
      headerName: "LastName",
      width: 170,
      headerAlign: "center",
    },
    {
      field: "username",
      headerName: "Username",
      width: 170,
      headerAlign: "center",
    },
    {
      field: "role",
      headerName: "Role",
      width: 100,
      cellClassName: "center",
      headerAlign: "center",
    },
    {
      field: "isActive",
      headerName: "Trạng thái",
      headerAlign: "center",
      width: 250,
      cellClassName: "center",
      renderCell: (params) => <StatusRow params={params} />,
    },
  ];
  //xử lý modal
  const openThemLoaiUser = () => {
    setOpenuser(true);
  };

  const handleupdateClose = () => {
    setOpenupdateuser(false);
    setUpdateObj({});
  };
  const handleClose = () => setOpenuser(false);
  const handleCloseWarning = () => setOpenWarning(false);
  const showNotification = (ms, icon, color) => {
    setAlert(true);
    setMessage(ms);
    setIcon(icon);
    setColor(color);
    setTimeout(function () {
      setAlert(false);
    }, 3000);
  };

  React.useEffect(() => {
    getListUsers();
    getroles();
  }, []);
  return (
    <GridContainer>
      <GridItem
        xs={12}
        sm={10}
        md={12}
        style={{ marginTop: 5, marginBottom: 10 }}
      >
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={openThemLoaiUser}
        >
          Thêm mới
        </Button>
        <Button
          variant="contained"
          onClick={changeStatus}
          style={{
            marginLeft: 10,
            color: "#fff",
            backgroundColor: "#149314",
            height: 27,
          }}
        >
          Đổi trạng thái
        </Button>
        <Button
          variant="contained"
          onClick={resetmatkhau}
          color="warning"
          disabled={disableBT}
          style={{ marginLeft: 10, height: 27 }}
        >
          Reset mật khẩu
        </Button>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={listUsers}
            columns={userscolumn}
            // rowsPerPageOptions={[]}
            // hideFooter={true}
            checkboxSelection={false}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setUpdateObj(params.row);
                event.defaultMuiPrevented = true;
                setOpenupdateuser(true);
              }
            }}
            onRowClick={(params, event) => {
              setUpdateLoaiUser(params.row.isActive);
              setUpdateId(params.row.id);
              event.defaultMuiPrevented = true;
              setDisableBT(false);
            }}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
        <a style={{ color: "#e50606", fontWeight: 700 }}>
          (*) Mật khẩu mặc định: vnpt123456
        </a>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color={color}
            icon={icon}
            message={message}
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Reset mật khẩu thành công"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridItem>

      {/* S--Thêm  user--S */}
      <Modal
        open={openthemuser}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <h6
                    className={classes.cardTitleWhite}
                    style={{ marginTop: "-5px" }}
                  >
                    Thêm user
                  </h6>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên"
                          variant="outlined"
                          size="small"
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              firstName: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tài khoản"
                          variant="outlined"
                          size="small"
                          //inputProps={{ maxLength: 3 }}
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              username: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <InputLabel style={{ marginTop: "-8px" }}>
                          Chọn role
                        </InputLabel>
                        <Select
                          defaultValue=""
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              role: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                          size="small"
                        >
                          {typeof roles === "object" &&
                            roles.map((prop, i) => {
                              return (
                                <MenuItem key={i} value={prop.rolE_ID}>
                                  {prop.rolE_NAME}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      style={{ height: 27 }}
                      onClick={themUser}
                    >
                      Thêm
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleClose}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                        height: 27,
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Thêm  user--E */}
      {/* S--Sửa  user--S */}
      <Modal
        open={openupdateuser}
        onClose={handleupdateClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Cập nhật user
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleupdateClose} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên"
                          variant="outlined"
                          size="small"
                          value={
                            updateObj.firstName == null
                              ? ""
                              : updateObj.firstName
                          }
                          onChange={(event) => {
                            const obj = {
                              ...updateObj,
                              firstName: event.target.value,
                            };
                            setUpdateObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Username"
                          variant="outlined"
                          size="small"
                          value={
                            updateObj.username == null ? "" : updateObj.username
                          }
                          disabled
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <InputLabel style={{ marginTop: "-8px" }}>
                          Chọn role
                        </InputLabel>
                        <Select
                          defaultValue=""
                          value={updateObj.role}
                          onChange={(event) => {
                            const obj = {
                              ...updateObj,
                              role: event.target.value,
                            };
                            setUpdateObj(obj);
                          }}
                          size="small"
                        >
                          {typeof roles === "object" &&
                            roles.map((prop, i) => {
                              return (
                                <MenuItem key={i} value={prop.rolE_ID}>
                                  {prop.rolE_NAME}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={suaUser}
                      style={{ height: 27 }}
                    >
                      Cập nhật
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleupdateClose}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                        height: 27,
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Sửa  user--E */}

      {/* S--Warning modal--S */}
      <Modal
        open={openwarning}
        onClose={handleCloseWarning}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Thông báo
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleCloseWarning} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5>{warrningContent}</h5>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      variant="contained"
                      onClick={handleCloseWarning}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Upload  roles--E */}
    </GridContainer>
  );
}
